import React, { useEffect, useState } from 'react';
import MiembrosComite from './MiembrosComite';
import * as yup from 'yup';
import es from '../../../../yup-es';
import { Button, Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { fetchRolComite } from '../gestionConcursoSlice';
import { CONCURSOAPI } from '../../../../const';
import axios from 'axios';
import ErrorMsg from '../../../../components/CompUtils/ErrorMsg';
import { useHistory } from 'react-router';
import { finEtapa } from '../gestionConcursoSlice';
import { finalize, init } from '../../../../components/GlobalFeedback/feedbackSlice';
import { AlertaDialog } from '../../../../components/CompUtils/Alerta';

yup.setLocale(es);

const CargaCoordConcur = ({ concurso }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [alert, setAlert] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const [comite, setComite] = useState({ usuarios: {} });

  const onConfirmar = () => {
    dispatch(init());

    //Acomodo la estructura de usuarios del comité para que coincida con el backend
    const usuarios = Object.keys(comite.usuarios).reduce((acum, curKey) => {
      acum[curKey] = comite.usuarios[curKey].reduce((rolesAcum, rol) => {
        return [
          ...rolesAcum,
          {
            idUsuario: rol.idUsuario,
            titular: rol.titular,
            representacion: rol.representacion,
          },
        ];
      }, []);
      return acum;
    }, {});

    const reqData = {
      idComite: concurso.comite[0].idComite,
      idLlamadoConcurso: concurso.idLlamadoConcurso,
      usuarios,
    };

    setErrorMsg('');
    axios
      .post(`${CONCURSOAPI}/llamadoconcurso/comites`, reqData)
      .then((res) => {
        dispatch(finalize());
        setAlert(true);
      })
      .catch((error) => {
        dispatch(finalize());
        if (error.response) {
          setErrorMsg('Error al intentar actualizar el comite.');
        } else if (error.request) {
          setErrorMsg('Error al intentar actualizar el comite.');
        } else {
          setErrorMsg(error.message);
        }
      });
  };

  const finalizarConfirmacion = () => {
    setAlert(false);
    history.push('/concursos');
    dispatch(finEtapa());
  };

  const contextValue = { comite, setComite };
  useEffect(() => {
    dispatch(fetchRolComite());
  }, []);
  return (
    <>
      <Container fluid>
        <h3 className="text-center">Designación de Coordinador Concursal</h3>
        <br />

        <MiembrosComite
          idConcurso={concurso.idLlamadoConcurso}
          comiteRecived={comite}
          newComite={(newComite) => setComite(newComite)}
        />

        {errorMsg && <ErrorMsg msg={errorMsg} />}
        <br />
        <Button variant="success" onClick={onConfirmar}>
          Confirmar
        </Button>
      </Container>

      <AlertaDialog size="sm" show={alert} onClose={finalizarConfirmacion} closeText="Cerrar">
        <div className="text-center">
          <i
            className="text-success fa fa-check-circle-o"
            style={{ fontSize: 64, WebkitTextStroke: '5px white' }}></i>
          <p>La información ha sido enviada al Coordinador Concursal</p>
        </div>
      </AlertaDialog>
    </>
  );
};

export default CargaCoordConcur;
